import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
// import PatientDetails from '../components/PatientDetailsForm.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    query: {
      secret: '',
      firstname: '',
      lastname: '',
      birthname: '',
      birthdate: '',
      gender: null,
      street: '',
      houseNumber: '',
      postCode: '',
      town: '',
      insuranceNumber: '',
      caseId: '',
      patientId: '',
      organisation: '',
      redirectUri: ''
    }
  },
  // {
  //   path: '/datenspende/patient-details/new/',
  //   name: 'patient-details',
  //   component: PatientDetails
    
  //   // props: true
  // }
]

const router = new VueRouter({
  base: process.env.VUE_APP_BASE_URL,
  routes,
  mode: "history"
})

export default router
